import {
  CreateLocationNoteRequest,
  CreateLocationNoteResponse,
} from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useCreateLocationNote(locationId: string) {
  const url = `/v2/orm/location_notes/locations/${locationId}/notes`;
  const request = new Request(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return useAuthenticatedMutation<
    CreateLocationNoteResponse,
    CreateLocationNoteRequest
  >(request, {
    onSuccessInvalidationKeys: [['location_notes', locationId]],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
  });
}
